module.exports = "\r\n.huge {\r\n    font-size: 40px;\r\n}\r\n\r\n.panel-green{\r\n    border-color: #5cb85c;\r\n}\r\n\r\n.panel-green .panel-heading {\r\n    border-color: #5cb85c;\r\n    color: white;\r\n    background-color: #5cb85c;\r\n}\r\n\r\n.panel-body .list-group-item{\r\n    border: 0;\r\n}\r\n\r\n.dashboard_page_header{\r\n    padding-bottom: 9px;\r\n    margin: 10px 0 20px;\r\n    border-bottom: 1px solid #eee;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/devotee/devotee-dashboard/devotee-dashboard.component.css
// module id = ./src/app/devotee/devotee-dashboard/devotee-dashboard.component.css
// module chunks = main